import * as React from "react";

import {
  useTheme,
  Box,
  Stack,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import NavBar from "./NavBar";
import bg_image from "../images/points_world.webp";
import me from "../images/plant.png";
import DownloadCV from "./DownloadCV";

const HeroSection = ({}) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down(1000));
  const screen490 = useMediaQuery(theme.breakpoints.down(490));
  const mobileScreen = useMediaQuery(theme.breakpoints.down(1000));

  return (
    <Stack
      sx={{
        backgroundImage: `url(${bg_image})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // pt: "1rem",
      }}
    >
      <NavBar />
      <Stack
        sx={{
          alignItems: "center",
          pb: smallScreen ? "5rem" : "10rem",
          pt: smallScreen ? "10rem" : "15rem",
          px: "10%",
          bgcolor: "#05103AAA",
        }}
      >
        <img
          src={me}
          alt="me"
          style={{
            marginBottom: "1rem",
            width: "100px",
          }}
        />
        <Typography
          component={"h1"}
          sx={{
            fontFamily: "'Oswald', sans-serif",
            fontWeight: 700,
            textAlign: "center",
            fontSize: smallScreen ? "28px" : "38px",
            mb: "1rem",
            color: theme.palette.whiteColor.main,
          }}
        >
          CRISPIN CIRHUZA ZAGABE
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: smallScreen ? "12px" : "14px",
            fontWeight: theme.typography.fontWeightLight,
            color: theme.palette.whiteColor.main,
            mb: "2.5rem",
            width: smallScreen ? "90%" : "70%",
          }}
        >
          A smart thinker software architect and developer breaking down
          enterprise-grade complex challenges with digital and numerical
          solutions{" "}
        </Typography>
        <Stack
          direction={screen490 ? "column" : "row"}
          sx={{
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <a
            href="https://wa.me/+243896541721"
            style={{
              textDecoration: "none",
              display: "flex",
              width: "max-content",
              // flexGrow: 1,
              justifyContent: "flex-end",
            }}
          >
            <Button
              sx={{
                transition: "all .3s",
                transform: "translateY(-10px)",
                background: "transparent",
                borderRadius: "70px",
                border: `2px solid ${theme.palette.whiteColor.main}`,
                px: mobileScreen ? "0.5rem" : "1.3rem",
                py: mobileScreen ? "0.2rem" : ".7rem",
                color: theme.palette.whiteColor.main,
                "&:hover": {
                  transition: "all .3s",
                  transform: "translateY(-5px)",
                  color: theme.palette.primary.main,
                  bgcolor: theme.palette.whiteColor.main,
                },
                textTransform: "none",
                fontSize: "14px",
                fontWeight: theme.typography.fontWeightBold,
              }}
            >
              Contact your Solution Maker
            </Button>
          </a>
          <Box
            sx={{
              transition: "all .3s",
              transform: "translateY(-10px)",
              bgcolor: theme.palette.common.white,
              borderRadius: "70px",
              border: `2px solid ${theme.palette.whiteColor.main}`,
              px: mobileScreen ? "0.5rem" : "1.3rem",
              ml: screen490 ? undefined : "1rem",
              py: mobileScreen ? "0.2rem" : ".7rem",
              color: theme.palette.whiteColor.main,
              fontWeight: theme.typography.fontWeightRegular,
              "&:hover": {
                transition: "all .3s",
                transform: "translateY(-5px)",
                color: theme.palette.primary.main,
                bgcolor: theme.palette.whiteColor.main,
              },
              mt: screen490 ? ".5rem" : undefined,
            }}
          >
            <DownloadCV />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default HeroSection;
